import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountsComponent } from './accounts/accounts.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard } from '../core/core.module';
import { OverviewComponent } from './overview/overview.component';
import { StatementsComponent } from './statements/statements.component';
import { BatchListComponent } from './batch-list/batch-list.component';
import { BatchDetailComponent } from './batch-detail/batch-detail.component';
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { BatchEditDialogComponent } from './batch-edit-dialog/batch-edit-dialog.component';
import { CashListComponent } from './cash-list/cash-list.component';
import { ContributionEditDialogComponent } from './contribution-edit-dialog/contribution-edit-dialog.component';
import { BulkContributionDialogComponent } from './bulk-contribution-dialog/bulk-contribution-dialog.component';
import { BankAmountDialogComponent } from './bank-amount-dialog/bank-amount-dialog.component';
import { ClassisListComponent } from './classis-list/classis-list.component';
import { ReportComponent } from './report/report.component';
import { GeneralFundDialogComponent } from './report/general-fund-dialog/general-fund-dialog.component';
import { DoubleCheckDialogComponent } from './double-check-dialog/double-check-dialog.component';
import { PledgeListComponent } from './pledge-list/pledge-list.component';
import { PledgeDetailComponent } from './pledge-detail/pledge-detail.component';
import { ReconciliationSearchComponent } from './reconciliation-search/reconciliation-search.component';
import { OnlineContributionsComponent } from './online-contributions/online-contributions.component';
import { OfferingScheduleComponent } from './offering-schedule/offering-schedule.component';
import { OfferingScheduleDialogComponent } from './offering-schedule-dialog/offering-schedule-dialog.component';
import { OnlineGivingSearchComponent } from './online-giving-search/online-giving-search.component';
import { BasicLayoutComponent } from '../common/layouts/basicLayout.component';
import { OnlineSummaryDialogComponent } from './online-summary-dialog/online-summary-dialog.component';
import { DepositOverviewComponent } from './deposit-overview/deposit-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'giving',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    {
                        path: 'overview',
                        component: OverviewComponent,
                        data: { title: 'Giving' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'batches',
                        component: BatchListComponent,
                        data: { title: 'Giving - Batches' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'batches/:id',
                        component: BatchDetailComponent,
                        data: { title: 'Giving - Batches' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'statements',
                        component: StatementsComponent,
                        data: { title: 'Giving - Statements' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'accounts',
                        component: AccountsComponent,
                        data: { title: 'Giving - Accounts' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'cash-list',
                        component: CashListComponent,
                        data: { title: 'Cash List' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'classis',
                        component: ClassisListComponent,
                        data: { title: 'Classis List' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'reports',
                        component: ReportComponent,
                        data: { title: 'Reports' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'pledges',
                        component: PledgeListComponent,
                        data: { title: 'Giving - Pledges' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'pledges/:id',
                        component: PledgeDetailComponent,
                        data: { title: 'Giving - Pledge' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'reconciliation',
                        component: ReconciliationSearchComponent,
                        data: { title: 'Reconciliation' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'schedule',
                        component: OfferingScheduleComponent,
                        data: { title: 'Offering Schedule' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'online',
                        component: OnlineContributionsComponent,
                        data: { title: 'Online Giving' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'online-overview',
                        component: OnlineGivingSearchComponent,
                        data: { title: 'Online Giving - Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'deposits',
                        component: DepositOverviewComponent,
                        data: { title: 'Deposit Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        AccountDetailComponent,
        BankAmountDialogComponent,
        BatchDetailComponent,
        BatchEditDialogComponent,
        BatchListComponent,
        BulkContributionDialogComponent,
        DepositOverviewComponent,
        OfferingScheduleDialogComponent,
        OnlineContributionsComponent,
        OnlineGivingSearchComponent,
        OverviewComponent,
        PledgeDetailComponent,
        ReconciliationSearchComponent,
    ],
})
export class GivingModule {}
